<template>
  <VanPopup
    v-model="show"
    round
    safe-area-inset-bottom
    position="bottom"
    :close-on-click-overlay="false"
    overlay-class="custom-van-popup-overlay"
    class="custom-van-popup"
  >
    <VanPicker
      ref="areaPicker"
      :default-index="defaultIndex"
      show-toolbar
      value-key="label"
      :item-height="50"
      :columns="pickerList"
      :visible-item-count="5"
      class="custom-van-picker"
      @confirm="onConfirm"
    >
      <template #default>
        <div class="header">
          <div class="btn cancel" @click="onCancel">取消</div>
          <div>
            <div class="title">选择运营区域</div>
            <div class="desc">您将在所选运营区域选站乘车</div>
          </div>
          <div class="btn confirm" @click="onClickConfirm">确定</div>
        </div>
      </template>
    </VanPicker>
  </VanPopup>
</template>

<script>
export default {
  name: "AreaPicker",
  model: {
    prop: "show",
    event: "change",
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    defaultIndex: {
      type: Number,
      default: 0,
    },
    columns: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  computed: {
    pickerList() {
      return this.columns[0] || [];
    },
  },
  // 重新设置默认选中项
  watch: {
    show(val) {
      if (val) {
        const areaPicker = this.getAreaPicker();
        if (areaPicker) {
          areaPicker.setIndexes([this.defaultIndex]);
        }
      }
    },
  },
  methods: {
    getAreaPicker() {
      return this.$refs.areaPicker;
    },
    onClickConfirm() {
      const areaPicker = this.getAreaPicker();
      if (areaPicker) {
        areaPicker.confirm();
      }
    },
    onConfirm(value, index) {
      this.$emit("confirm", value, index);
    },
    onCancel() {
      this.$emit("cancel");
    },
  },
};
</script>

<style scoped lang="scss">
.header {
  width: 100%;
  height: 80px;
  padding: 18px 20px;
  display: flex;
  justify-content: space-between;
}
.title {
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 16px;
  color: #000000;
  line-height: 22px;
  text-align: center;
  font-style: normal;
}
.desc {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
  line-height: 17px;
  text-align: center;
  font-style: normal;
  margin-top: 6px;
}

.btn {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  text-align: left;
  font-style: normal;
}

.cancel {
  color: #666666;
}

.confirm {
  color: #006efa;
  font-weight: 500;
}
</style>
